import React from 'react';

const SignInForm = React.lazy(() => import('./SingIn'));

/**
 * Lazy loaded sign in form
 */
const LazySignInForm = () => (
  <React.Suspense fallback={<div>Yüklənir...</div>}>
    <SignInForm />
  </React.Suspense>
);

export default LazySignInForm;
